<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <form
    #df="ngForm"
    novalidate
    (keydown.enter)="onSearchFundData()"
    class="formborder"
  >
    <div class="row m-0 col-md-12 p-0 align-items-center">
      <div class="col-md-2">
        <span class="required-lable">Date From</span>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="CaseDateFrom"
            id="FromDate"
            [min]="minDate"
            [max]="maxDate"
            class="form-control input-text-css"
            [(ngModel)]="FromDate"
            (dateChange)="DateChange()"
            required
            #refFromDate="ngModel"
            [ngClass]="{
              'is-invalid': df.submitted && refFromDate.invalid,
              'alert-warning':
                refFromDate.invalid &&
                (refFromDate.dirty ||
                  refFromDate.touched ||
                  refFromDate.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>
      <div class="col-md-2">
        <span class="required-lable">Date To</span>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker2"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="ToDate"
            id="ToDate"
            (dateChange)="DateChange()"
            [min]="minDate"
            [max]="maxDate"
            class="form-control input-text-css"
            [(ngModel)]="ToDate"
            required
            #reffToDate="ngModel"
            [ngClass]="{
              'is-invalid': df.submitted && reffToDate.invalid,
              'alert-warning':
                reffToDate.invalid &&
                (reffToDate.dirty ||
                  reffToDate.touched ||
                  reffToDate.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
      </div>

      <div class="col-md-2 text-right mb-2">
        <button
          type="button"
          (click)="onSearchFundData()"
          class="mt-3 btn font-size-12 button-btn"
          [disabled]="!df.form.valid"
        >
          Search
        </button>
      </div>
      <div class="col-md-3 mb-1">
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input
                type="text"
                id="FilterInputSearch"
                (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch"
                placeholder="What're you searching for?"
                class="form-control border-0 bg-light mt-2"
              />
              <div class="input-group-append">
                <button
                  id="button-addon1"
                  type="submit"
                  class="btn btn-link text-primary"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>
 <div class="fund-summary-wrapper" [hidden]="!DataSourcetop">
  <mat-card class="fund-summary-card">
    <div class="fund-summary-grid">
      
      <div class="summary-box">
        <span class="label">Increase in Application of Fund</span>
        <span class="amount">{{ IncreaseInApplicationOfFund | number:'1.2-2' }}</span>
      </div>

      <div class="summary-box">
        <span class="label">Decrease in Application of Fund</span>
        <span class="amount">{{ DecreaseInApplicationOfFund | number:'1.2-2' }}</span>
      </div>

      <div class="summary-box">
        <span class="label">Increase in Source of Fund</span>
        <span class="amount">{{ IncreaseInSourceOfFund | number:'1.2-2' }}</span>
      </div>

      <div class="summary-box">
        <span class="label">Decrease in Source of Fund</span>
        <span class="amount">{{ DecreaseInSourceOfFund | number:'1.2-2' }}</span>
      </div>

    </div>
  </mat-card>
</div>

  <div class="mt-3" [hidden]="!DataSource">
    <div class="">
      <div class="table-responsive" style="overflow: auto">
        <table
          class="table-bordered"
          mat-table
          matSort
          matTableExporter
            #exporter="matTableExporter"
          [dataSource]="DataSource"
        >
          <ng-container matColumnDef="AccountId">
            <th mat-header-cell *matHeaderCellDef class="width50" >
              #
            </th>
            <td mat-cell *matCellDef="let row; let i = index" class="width50">
              {{ matpaginatorref.pageIndex * matpaginatorref.pageSize + (i + 1) }}
            </td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Account_Name">
            <th mat-header-cell *matHeaderCellDef>
              Account Name
            </th>
            <td mat-cell *matCellDef="let row">{{ row.Account_Name }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Group_Name">
            <th mat-header-cell *matHeaderCellDef>
              Group Name
            </th>
            <td mat-cell *matCellDef="let row">{{ row.Group_Name }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="UpperGroupName">
            <th mat-header-cell *matHeaderCellDef>UpperGroupName</th>
            <td mat-cell *matCellDef="let row">{{ row.UpperGroupName }}</td>
            <th mat-footer-cell *matFooterCellDef>Total</th>
          </ng-container>

          <ng-container matColumnDef="Opening_Balance">
            <th mat-header-cell *matHeaderCellDef>Opening Balance</th>
            <td mat-cell *matCellDef="let row">{{ row.Opening_Balance }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>
           <ng-container matColumnDef="Closing_Balance">
            <th mat-header-cell *matHeaderCellDef>Closing Balance</th>
            <td mat-cell *matCellDef="let row">{{ row.Closing_Balance }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>
           <ng-container matColumnDef="ChangeInMomentSource">
            <th mat-header-cell *matHeaderCellDef>ChangeInMomentSource</th>
            <td mat-cell *matCellDef="let row">{{ row.ChangeInMomentSource }}</td>
            <th mat-footer-cell *matFooterCellDef> {{ totaltypewise("ChangeInMomentSource") }}</th>
          </ng-container>
           <ng-container matColumnDef="ChangeInMomentApplication">
            <th mat-header-cell *matHeaderCellDef>ChangeInMomentApplication</th>
            <td mat-cell *matCellDef="let row">{{ row.ChangeInMomentApplication }}</td>
            <th mat-footer-cell *matFooterCellDef>{{ totaltypewise("ChangeInMomentApplication") }}</th>
          </ng-container>
           <ng-container matColumnDef="NonMomentFund">
            <th mat-header-cell *matHeaderCellDef>NonMomentFund</th>
            <td mat-cell *matCellDef="let row">{{ row.NonMomentFund }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          

          <ng-container matColumnDef="Action">
            <th
              mat-header-cell
             
              class="grid-header"
              *matHeaderCellDef
            >
              View Detail
            </th>
            <td
              mat-cell
              *matCellDef="let row; let i = index"
              class="text-center"
            >
             <i
                  class="fa fa-arrow-circle-right arrow-circle action-btn"
                  (click)="onSearchAccountStatement(row)"
                  aria-label="true"
                ></i>
            </td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <tr
            mat-footer-row
            class="sticky-footer fontcolor"
            *matFooterRowDef="displayedColumns; sticky: true"
          ></tr>
        </table>
      </div>
    </div>
  </div>
  <div class="row m-0 ml-3 mr-3 pt-2 pb-1" [hidden]="!DataSource">
    <div class="col-md-2">
      <button
        class="mt-3 btn font-size-12 button-btn"
        (click)="exportExcel()"
      >
        <i
          class="fa fa-file-export mr-1"
          style="font-size: medium; cursor: pointer"
        ></i>
        Export
      </button>
    </div>

    <div class="col-md-8 mt -3 text-right">
      <mat-paginator
        #matpaginatorref
        [pageSizeOptions]="[100]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</div>
<table
  id="fund-flow"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
    <tr class="table-header">
    <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
     IncreaseInApplicationOfFund
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      DecreaseInApplicationOfFund
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      IncreaseInSourceOfFund
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      DecreaseInSourceOfFund
    </th>
    </tr>
    <tr *ngFor="let x of FileCheckingList1; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.IncreaseInApplicationOfFund }}</td>
    <td>{{ x.DecreaseInApplicationOfFund }}</td>
    <td>{{ x.IncreaseInSourceOfFund }}</td>
    <td>{{ x.DecreaseInSourceOfFund }}</td>

    </tr>

  <tr class="table-header">
    <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Account Name
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Group Name
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      UpperGroupName
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Opening Balance
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Closing Balance
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      ChangeInMomentSource
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      ChangeInMomentApplication
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      NonMomentFund
    </th>
  </tr>

  <tr *ngFor="let x of FileCheckingList; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.Account_Name }}</td>
    <td>{{ x.Group_Name }}</td>
    <td>{{ x.UpperGroupName }}</td>
    <td>{{ x.Opening_Balance }}</td>
    <td>{{ x.Closing_Balance }}</td>
    <td>{{ x.ChangeInMomentSource }}</td>
    <td>{{ x.ChangeInMomentApplication }}</td>
    <td>{{ x.NonMomentFund }}</td>
  </tr>
  <tfoot>
    <tr class="table-footer">
      <td
        colspan="6"
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        <b>Total:</b>
      </td>

      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        <strong>
          {{ DataSource ? totaltypewise("ChangeInMomentSource") : "" }}
        </strong>
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        <strong>{{ DataSource ? totaltypewise("ChangeInMomentApplication") : "" }}</strong>
      </td>
    </tr>
  </tfoot>
</table>


<div
  class="modal fade in"
  id="accountingstatement"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div
    class="modal-dialog modal-dialog-centered"
    role="document"
    style="max-width: 71.25rem"
  >
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Accounting Statement Details
        </h6>
        <button
          type="button"
          class="close"
          (click)="OnCloseaccountingstatement()"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive" style="overflow: auto">
                <table
                class="table-bordered simple-table"
                mat-table
                matSort
                matTableExporter
                #modelexporter="matTableExporter"
                [dataSource]="dataSourcemodel"
                >
                <ng-container matColumnDef="voucherid">
                    <th mat-header-cell *matHeaderCellDef>#</th>
                    <td mat-cell *matCellDef="let row; let i = index">
                    {{ modelPaginator.pageIndex * modelPaginator.pageSize + (i + 1) }}
                    </td>
                    <th mat-footer-cell *matFooterCellDef></th>
                </ng-container>

                <ng-container matColumnDef="VoucherDate">
                    <th mat-header-cell *matHeaderCellDef>
                    Voucher Date
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.VoucherDate }}</td>
                    <th mat-footer-cell *matFooterCellDef></th>
                </ng-container>

                <ng-container matColumnDef="Voucher_No">
                    <th mat-header-cell *matHeaderCellDef>
                    Voucher No
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.Voucher_No }}</td>
                    <th mat-footer-cell *matFooterCellDef></th>
                </ng-container>

                <ng-container matColumnDef="CaseNo">
                    <th mat-header-cell *matHeaderCellDef>Loan No</th>
                    <td mat-cell *matCellDef="let row">{{ row.CaseNo }}</td>
                    <th mat-footer-cell *matFooterCellDef></th>
                </ng-container>

                <ng-container matColumnDef="accHead">
                    <th mat-header-cell *matHeaderCellDef>A/C Head</th>
                    <td mat-cell *matCellDef="let row">{{ row.accHead }}</td>
                    <th mat-footer-cell *matFooterCellDef>Total</th>
                </ng-container>

                <ng-container matColumnDef="TranTypeDR">
                    <th
                   
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-right"
                    >
                    DR Amount
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                    {{ row.TranTypeDR }}
                    </td>
                    <th mat-footer-cell *matFooterCellDef class="text-right">
                    {{ dataSource ? calculateACTranTypeDR() : "" }}
                    </th>
                </ng-container>

                <ng-container matColumnDef="TranTypeCR">
                    <th
                   
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-right"
                    >
                    CR Amount
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                    {{ row.TranTypeCR }}
                    </td>
                    <th mat-footer-cell *matFooterCellDef class="text-right">
                    {{ dataSource ? calculateACTranTypeCR() : "" }}
                    </th>
                </ng-container>

                <ng-container matColumnDef="TranTypeTotal">
                    <th
                   
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-right"
                    >
                    Balance
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                    {{ row.TranTypeTotal }}
                    </td>
                    <th mat-footer-cell *matFooterCellDef class="text-right">
                    {{ dataSource ? calculateACTranTypeTotal() : "" }}
                    </th>
                </ng-container>

                <ng-container matColumnDef="Narration">
                    <th mat-header-cell *matHeaderCellDef>Narration</th>
                    <td mat-cell *matCellDef="let row">{{ row.Narration }}</td>
                    <th mat-footer-cell *matFooterCellDef></th>
                </ng-container>
                <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsmodel; sticky: true"
                ></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsmodel"></tr>
                <tr
                    mat-footer-row
                    class="sticky-footer fontcolor"
                    *matFooterRowDef="displayedColumnsmodel; sticky: true"
                ></tr>
                </table>
            </div>
          </div>
        </div>
        <div class="row m-0 pb-1">
          <div class="col-md-2">
            <button
                class="mt-3 btn font-size-12 button-btn"
                (click)="exportmodel()"
            >
                <i
                class="fa fa-file-export mr-1"
                style="font-size: medium; cursor: pointer"
                ></i>
                Export
            </button>
            </div>
          <div class="col-md-12 text-right mt-3">
            <mat-paginator
              #modelPaginator
              [pageSizeOptions]="[20, 50]"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>